import React from 'react'

function Footer() {
  return (
    <div className='footer'>
      <h3>This project was made by Andrew J Salas</h3>
    </div>
  )
}

export default Footer